import Repository from "./Repository";
import { httpClient } from "@/shared/services";

const resource = "/patients";

const createPatient = payload => {
  return httpClient.post(resource, payload).then(res => res.data);
};

export { createPatient };

export default {
  get() {
    return Repository.get(`${resource}`);
  },

  getPatient(patientUuid) {
    return Repository.get(`${resource}/${patientUuid}`);
  },

  /**
   * Create a patient on server
   * @param payload patient payload
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
